import type { ReactNode } from 'react'

import { cn } from '@/_lib/utils'

export function APatientInfoSectionHeading({
	children,
	className
}: {
	children: ReactNode
	className?: string
}) {
	return (
		<h2
			className={cn(
				'mb-3 md:mb-4 text-xs font-semibold uppercase tracking-widest text-medante-purple-dark',
				className
			)}
		>
			{children}
		</h2>
	)
}
